import { useState } from "react";
import { motion } from "framer-motion";
import { Bell, Play } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function NotifySection({ playstoreUrl }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/notify", { email });
      toast.success(
        data.message === "already"
          ? "You're already on the list. Legend."
          : "You're in! We'll ping you at launch."
      );
      setEmail("");
    } catch {
      toast.error("Hmm, that email doesn't look right.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="notify" className="relative px-4 py-24 sm:px-8 sm:py-32">
      <div className="hero-blob absolute inset-0" />
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto max-w-2xl text-center"
      >
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-[#00F0FF]/40 bg-[#00F0FF]/10">
          <Bell size={22} className="text-[#00F0FF]" />
        </span>
        <h2 className="font-display mt-7 text-3xl font-extrabold text-white sm:text-4xl">
          NEVER MISS A <span className="text-glow-cyan">DUEL</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm text-[#94A3B8] sm:text-base">
          Drop your email for launch news, seasonal tournaments and exclusive
          badge drops. Zero spam, only adrenaline.
        </p>
        <form onSubmit={submit} className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@galaxy.com"
            data-testid="notify-email-input"
            className="glass flex-1 rounded-full px-5 py-3.5 font-sub text-sm text-white placeholder:text-[#64748B] focus:border-[#00F0FF] focus:outline-none"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="notify-submit-button"
            className="btn-neon rounded-full bg-[#FF007A] px-7 py-3.5 font-sub text-sm font-bold text-white disabled:opacity-60"
          >
            {loading ? "Joining..." : "Notify Me"}
          </button>
        </form>
        <a
          href={playstoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="notify-playstore-link"
          className="mt-8 inline-flex items-center gap-2 font-code text-xs tracking-widest text-[#64748B] transition-colors hover:text-[#00F0FF]"
        >
          <Play size={12} /> FREE ON GOOGLE PLAY — ANDROID ONLY
        </a>
      </motion.div>
    </section>
  );
}
